<template>
	<svg class="chevron hero__link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 17" fill="currentColor">
		<path d="M1.133 7.75a.89.89 0 000 1.248l7.334 7.373c.378.34.945.34 1.286 0l.87-.87c.34-.34.34-.907 0-1.285L4.8 8.393l5.822-5.86c.34-.378.34-.945 0-1.285l-.87-.87c-.34-.34-.907-.34-1.285 0L1.133 7.751z" fill="#fff"/>
	</svg>
</template>
